/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairSearchParameters } from '../../models/finnair-search-parameters';
import { OfferList } from '../../models/offer-list';

export interface FindOfferList$Params {

/**
 * Bearer token
 */
  Authorization: any;
      body: FinnairSearchParameters
}

export function findOfferList(http: HttpClient, rootUrl: string, params: FindOfferList$Params, context?: HttpContext): Observable<DapiHttpResponse<OfferList>> {
  const rb = new DapiRequestBuilder(rootUrl, findOfferList.PATH, 'post');

  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<OfferList>;
    }),
    catchErrorAsJson()
  );
}

findOfferList.PATH = '/api/offerList';
